import React, { useState } from "react";
import { Table, Select, Button, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import styles from "./AdminEmergencyContactDetails.module.css";
import { useNavigate } from "react-router-dom";
import actionicon from "../../../assets/images/actionicon.svg";

import HeaderComponent from "../../../components/HeaderComponent/HeaderComponent";
import {
  Dropdown,
  InputField,
  Modal,
  SubmitButton,
  TextComponent,
} from "../../../components";
import ModalLeft from "../../../components/ModalLeft/ModalLeft";
import { phoneFormat } from "../../../utills";

const { Option } = Select;

const AdminEmergencyContactDetails = () => {
  const navigate = useNavigate();
  const [BuisnessType, setBuisnessType] = useState({});
  const [AddContactModal, setAddContactModal] = useState(false);
  const [editContactModal, setEditContactModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [ContactName, setContactName] = useState("");
  const [ContactNo, setContactNo] = useState("");
  const [EditContactName, setEditContactName] = useState("");
  const [EditContactNo, setEditContactNo] = useState("");
  const columns = [
    {
      title: "No",
      dataIndex: "No",
      key: "No",
    },
    {
      title: "Name",
      dataIndex: "Name",
      key: "Name",
    },
    {
      title: "Numbers",
      dataIndex: "Numbers",
      key: "Numbers",
    },

    {
      title: "Action",
      key: "Action",
      dataIndex: "Action",
      render: (text, record) => (
        <Dropdown
          className={styles.inputNew}
          value={BuisnessType[record.No] || text}
          // value={BuisnessType}
          labelStyle={{ fontSize: 18 }}
          inputStyle={{
            backgroundColor: "#F7F8F9",
            border: "1.5px solid #E8ECF4",
          }}
          options={[
            {
              value: "Edit",
              id: 1,
            },
            {
              value: "Delete",
              id: 2,
            },
          ]}
          // onChange={(e) => setBuisnessType(e)}
          onChange={(selectedOption) => {
            const value =
              typeof selectedOption === "object"
                ? selectedOption.value
                : selectedOption;

            setBuisnessType((prev) => ({ ...prev, [record.No]: value }));
          }}
        />
      ),
    },
    {
      title: "",
      key: "Button",
      dataIndex: "Button",
      // render: (text, record) => record.Button,

      render: (_, record) => (
        <SubmitButton
          title={"Continue"}
          btnClass={styles.tableBtn}
          primary
          onClick={() => {
            const selectedAction = BuisnessType[record.No] || record.Action;
            // navigate(`/EquipmentDetails/${selectedAction}`);
            // navigate("/EquipmentDetails/view");

            if (selectedAction === "Edit") {
              setEditContactModal(true);
            } else if (selectedAction === "Delete") {
              setDeleteModal(true);
            }
          }}
        />
      ),
    },
  ];

  const data = [
    {
      No: "1",
      Name: "National Emergency",
      Numbers: "911",
      Action: "Edit",
      // Button: (
      //   <SubmitButton
      //     primary
      //     btnContainerClass={styles.btnContainer}
      //     btnClass={styles.btnClass}
      //     title="Continue"
      //   />
      // ),
    },
    {
      No: "2",
      Name: "Health & Safety",
      Numbers: "911",
      Action: "Delete",
      // Button: (
      //   <SubmitButton
      //     primary
      //     btnContainerClass={styles.btnContainer}
      //     btnClass={styles.btnClass}
      //     title="Continue"
      //   />
      // ),
    },
    {
      No: "3",
      Name: "Transportation Security",
      Numbers: "1-800-222-1222",

      Action: "Edit",
      // Button: (
      //   <SubmitButton
      //     primary
      //     btnContainerClass={styles.btnContainer}
      //     btnClass={styles.btnClass}
      //     title="Continue"
      //   />
      // ),
    },
    {
      No: "4",
      Name: "FBI Tip Line",
      Numbers: "1-800-222-1222",

      Action: "Delete",
      // Button: (
      //   <SubmitButton
      //     primary
      //     btnContainerClass={styles.btnContainer}
      //     btnClass={styles.btnClass}
      //     title="Continue"
      //   />
      // ),
    },
    {
      No: "5",
      Name: "Occupational Safety ",
      Numbers: "1-800-222-1222",
      Action: "Edit",
      // Button: (
      //   <SubmitButton
      //     primary
      //     btnContainerClass={styles.btnContainer}
      //     btnClass={styles.btnClass}
      //     title="Continue"
      //   />
      // ),
    },
    {
      No: "5",
      Name: "Amtrak Police ",
      Numbers: "1-800-331-0008",
      ShelfLife: "180 days",
      Action: "Delete",
      Button: (
        <SubmitButton
          primary
          btnContainerClass={styles.btnContainer}
          btnClass={styles.btnClass}
          title="Continue"
        />
      ),
    },
    {
      No: "6",
      Name: "Poison Control Center",
      Numbers: "1-800-331-0008",
      ShelfLife: "180 days",
      Action: "Edit",
      // Button: (
      //   <SubmitButton
      //     primary
      //     btnContainerClass={styles.btnContainer}
      //     btnClass={styles.btnClass}
      //     title="Continue"
      //   />
      // ),
    },
    {
      No: "7",
      Name: "Community services",
      Numbers: "211",
      Action: "Delete",
      // Button: (
      //   <SubmitButton
      //     primary
      //     btnContainerClass={styles.btnContainer}
      //     btnClass={styles.btnClass}
      //     title="Continue"
      //   />
      // ),
    },
  ];

  return (
    <div className={styles.mainCont}>
      {/* Heading Section with Right Controls */}
      <HeaderComponent
        heading={"Emergency Contact Details"}
        onSearch={(e) => console.log(e.target.value)}
        onSubmit={() => setAddContactModal(true)}
        submitButtonText={"Create New Contact"}
        showBackIcon={true}
        showFilterIcon={false}
        showSubmitButton={true}
        showSearch={true}
      />

      {/* Table Section */}
      <div className={styles.subCont}>
        <div className={styles.TableDiv}>
          <Table
            scroll={{ x: true }}
            columns={columns}
            dataSource={data}
            pagination={false}
            rowKey="No"
          />
        </div>
      </div>

      <ModalLeft
        open={AddContactModal}
        onCancel={() => setAddContactModal(false)}
        className={styles.modalCont}
        title={"Add New Contact"}
        buttonTitle={"save"}
        onBtnPress={() => setAddContactModal(false)}
        btnStyle={{ marginTop: "20px", width: "50%" }}
      >
        <div className={styles.modalContent}>
          <div className={styles.itemRow}>
            <div className={styles.search_div}>
              <InputField
                label="Contact Name"
                inputStyle={{
                  backgroundColor: "var(--bg-grey)",
                }}
                innerInput={{
                  backgroundColor: "var(--bg-grey)",
                  color: "var(--black-color)",
                }}
                placeholder={"Ambulance"}
                value={ContactName}
                onChange={(e) => setContactName(e.target.value)}
              />
              <InputField
                label="Contact Number"
                inputStyle={{
                  backgroundColor: "var(--bg-grey)",
                }}
                innerInput={{
                  backgroundColor: "var(--bg-grey)",
                  color: "var(--black-color)",
                }}
                placeholder={"199"}
                value={phoneFormat(ContactNo)}
                maxLength={11}
                type={"number"}
                onChange={(e) => setContactNo(e.target.value)}
              />
            </div>
          </div>
        </div>
      </ModalLeft>

      <ModalLeft
        open={editContactModal}
        onCancel={() => setEditContactModal(false)}
        className={styles.modalCont}
        title={"Edit Contact"}
        buttonTitle={"save"}
        onBtnPress={() => setEditContactModal(false)}
        btnStyle={{ marginTop: "20px", width: "50%" }}
      >
        <div className={styles.modalContent}>
          <div className={styles.itemRow}>
            <div className={styles.search_div}>
              <InputField
                label="Contact Name"
                inputStyle={{
                  backgroundColor: "var(--bg-grey)",
                }}
                innerInput={{
                  backgroundColor: "var(--bg-grey)",
                  color: "var(--black-color)",
                }}
                placeholder={"Ambulance"}
                value={EditContactName}
                onChange={(e) => setEditContactName(e.target.value)}
              />
              <InputField
                label="Contact Number"
                inputStyle={{
                  backgroundColor: "var(--bg-grey)",
                }}
                innerInput={{
                  backgroundColor: "var(--bg-grey)",
                  color: "var(--black-color)",
                }}
                placeholder={"199"}
                value={EditContactNo}
                maxLength={11}
                type={"number"}
                onChange={(e) => setEditContactNo(e.target.value)}
              />
            </div>
          </div>
        </div>
      </ModalLeft>

      {/* //////////////////////////  delete modal ///////////////////////// */}
      <Modal
        open={deleteModal}
        // onCancel={() => setDeleteModal(false)}
        className={styles.modalCont}
        title={"Delete Contact"}
        twoButton={true}
        okBtnTitle={"Yes"}
        cancelBtnTitle={"No"}
        onCancel={() => {
          setDeleteModal(false);
        }}
        onClickOkButton={() => {
          setDeleteModal(false);
        }}
        onClickCancelButton={() => {
          setDeleteModal(false);
        }}
        //  onClickOkButton={setDeleteModal(false)}
        // onClickCancelButton={setDeleteModal(false)}
      >
        <div className={styles.modalContent}>
          <TextComponent
            text="Are you sure you want to delete this contact?"
            // className={styles.CardText}
          />
        </div>
      </Modal>
    </div>
  );
};

export default AdminEmergencyContactDetails;
